import CloseIcon from "@mui/icons-material/Close";
import { Alert, Box, Button, IconButton, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import useMessage from "../../../../hooks/useMessage";

export const SnackbarWrapper = () => {
  const { t } = useTranslation("common");

  const { wipeMessage } = useMessage();
  const message = useAppSelector((state) => state.message.message);
  const navigate = useNavigate();

  const isError = message.type === "error";

  const closeSnackbar = () => {
    wipeMessage();
  };

  const getAction = () => {
    const renderButton = (label: string, onClick: () => void) => (
      <Box display="flex" alignItems="center">
        <Button size="small" color="inherit" onClick={onClick}>
          {label}
        </Button>
        <IconButton size="small" color="inherit" onClick={closeSnackbar}>
          <CloseIcon sx={{ fontSize: "1.25rem" }} />
        </IconButton>
      </Box>
    );

    if (message.options?.link) {
      return renderButton(t("show"), () => navigate(message.options?.link!));
    }

    return null;
  };

  return (
    <div>
      <Snackbar
        open={!!message.text}
        message={message.text}
        autoHideDuration={isError ? null : 6000}
        onClose={isError ? undefined : closeSnackbar}
        sx={{ maxWidth: "750px" }}
      >
        <Alert
          sx={{ alignItems: "center", ".MuiAlert-action": { p: "0 0 0 16px" } }}
          severity={message.type}
          onClose={closeSnackbar}
          action={getAction()}
        >
          {message.text}
        </Alert>
      </Snackbar>
    </div>
  );
};
